module.exports = __webpack_public_path__ + "assets/images/audio@2x.d8b5f4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GuestBook/assets/audio@2x.png
// module id = 1627
// module chunks = 0